import classNames from "classnames";
import React, { useContext } from "react";
import PhoneNumberInput from "react-phone-number-input/react-hook-form-input";
import { FormContext } from "../../App";
import ErrorMessage from "../ErrorMessage/ErrorMessage";
import Label from "../Label/Label";
import style from "./PhoneInput.module.css";

interface PhoneInputProps {
  label: string;
  name: string;
  required?: boolean;
}

const PhoneInput: React.FC<PhoneInputProps> = ({ label, name, required }) => {
  const { control, errors } = useContext(FormContext);

  return (
    <div className={style.inputContainer}>
      <Label text={label} required={required} />
      <PhoneNumberInput
        name={name}
        control={control}
        rules={{
          required: required && "Required field",
        }}
        defaultValue=""
        type="tel"
        autoComplete="tel"
        placeholder="Enter phone number"
        className={classNames(style.inputElement, {
          [style.error]: errors[name],
        })}
      />
      <ErrorMessage name={name} />
    </div>
  );
};

export default PhoneInput;
